function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import PhotoCarouselItem from './photo-carousel-item';
import VirtualTourCarouselItem from './virtual-tour-carousel-item';
import VideoCarouselItem from './video-carousel-item';
import logEventForComponent from '../../utils/log-event-for-component';
import * as models from '../../models';
import * as styles from './carousel-item.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var logEvent = logEventForComponent('CarouselItem');
var ComponentMap = {
  FLOORPLAN: PhotoCarouselItem,
  PHOTO: PhotoCarouselItem,
  VIRTUAL_TOUR: VirtualTourCarouselItem,
  VIDEO: VideoCarouselItem
};
var CarouselItem = _ref => {
  var item = _ref.item,
    onClick = _ref.onClick,
    showOverlay = _ref.showOverlay,
    layout = _ref.layout;
  var _useState = useState(window.innerHeight),
    _useState2 = _slicedToArray(_useState, 2),
    innerHeight = _useState2[0],
    setInnerHeight = _useState2[1];
  var updateHeight = () => {
    if (window.innerHeight !== innerHeight) {
      setInnerHeight(window.innerHeight);
    }
  };
  useEffect(() => {
    window.addEventListener('resize', updateHeight);
    return () => {
      window.removeEventListener('resize', updateHeight);
    };
  });
  var Component = ComponentMap[item.type];
  return Component ? ___EmotionJSX(Component, {
    "data-testid": "testing",
    css: styles.carouselItem({
      innerHeight
    }),
    item: item,
    onClick: logEvent('onClick', onClick),
    showOverlay: showOverlay,
    layout: layout
  }) : null;
};
CarouselItem.propTypes = {
  item: PropTypes.shape(models.item).isRequired,
  showOverlay: PropTypes.bool,
  onClick: PropTypes.func,
  layout: PropTypes.shape(models.layout)
};
CarouselItem.defaultProps = {
  showOverlay: false,
  onClick: () => {},
  layout: {}
};
export default CarouselItem;